import { useQuery } from '@tanstack/react-query';
import type { VehicleSubscriptionsResponse } from '@//app/api/protected/subscriptions/vehicles';
import { useAuth } from '@//providers/AuthProvider';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetAuthorizedJson } from '../../httpClient';

export const VEHICLE_SUBSCRIPTIONS_CACHE_KEY = 'api/protected/subscriptions/vehicles';

const useVehicleSubscriptions = (enabled = true) => {
  const { initialized, decodedToken } = useAuth();
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<VehicleSubscriptionsResponse>({
    queryKey: [VEHICLE_SUBSCRIPTIONS_CACHE_KEY, decodedToken?.sub],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/protected/subscriptions/vehicles`;
      return await httpClientGetAuthorizedJson<VehicleSubscriptionsResponse>(url);
    },
    enabled: enabled && initialized,
  });

  return query;
};

export default useVehicleSubscriptions;
